import { TOGGLE_CYO_MODAL } from './cyo_actions';

export const toggleCyoModal = () => {
  return {
    type: TOGGLE_CYO_MODAL,
  };
};
